import { SELECTED_TAB } from "./types";

export const changeTabInSidebar = (tab) => async (dispatch) => {
  dispatch({
    type: SELECTED_TAB,
    payload: tab,
  });
};
